import React, { useState } from 'react';
import './BookDemo.css';
import MultiSelectDropdown from '../components/MultiSelectDropdown';
import ContactService from '../services/ContactService';
import CompanyLogo from '../images/VerticalLogo.png';

function BookDemo() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('');
  const [preferredTime, setPreferredTime] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus('');

    const demoData = {
      name,
      email,
      company,
      phone,
      subject,
      preferredTime,
      message,
      age: 35,
      annualNeeded: '120000',
      elseWhere: 50000,
      savingAmount: 1400,
      savingFrequency: 12
    };

    try {
      console.log('Submitting demo form:', demoData);
      const result = await ContactService.sendBookDemoForm(demoData);
      
      if (result.success) {
        setStatus(result.message);
        setSuccess(true);
        setName('');
        setEmail('');
        setCompany('');
        setPhone('');
        setSubject('');
        setPreferredTime('');
        setMessage('');
        
        // Show additional note if available
        if (result.note) {
          setTimeout(() => {
            setStatus(prev => prev + ' ' + result.note);
          }, 2000);
        }
      } else {
        setStatus(result.message);
        setSuccess(false);
      }
    } catch (error) {
      console.error('Demo form submission error:', error);
      setStatus('An unexpected error occurred. Please try again.');
      setSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-container container my-5">
      <div className="row">
        <div className="col-12">
          <h2 className="mb-4">Book a Demo</h2>
          {/* <form className="book-demo-form" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Name</label>
              <input 
                type="text" 
                className="form-control" 
                id="name" 
                placeholder="Your Name" 
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input 
                type="email" 
                className="form-control" 
                id="email" 
                placeholder="you@example.com" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="company" className="form-label">Company</label>
              <input 
                type="text" 
                className="form-control" 
                id="company" 
                placeholder="Your Company" 
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="phone" className="form-label">Phone</label>
              <input 
                type="tel" 
                className="form-control" 
                id="phone" 
                placeholder="Your Phone Number" 
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="preferredTime" className="form-label">Preferred Time</label>
              <input 
                type="datetime-local" 
                className="form-control" 
                id="preferredTime" 
                value={preferredTime}
                onChange={(e) => setPreferredTime(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="subject" className="form-label">Subject</label>
              <input 
                type="text" 
                className="form-control" 
                id="subject" 
                placeholder="Demo Subject" 
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea 
                className="form-control" 
                id="message" 
                rows="4" 
                placeholder="Your message here..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>
            </div>
            <button 
              type="submit" 
              className="btn btn-primary d-block mx-auto" 
              style={{backgroundColor: 'transparent', border: '2px solid #BFD42F', color: '#000', borderRadius:'16px'}}
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send Message'}
            </button>
          </form> */}
          {status && (
            <p style={{color: success ? 'green' : 'red', marginTop: '15px'}}>{status}</p>
          )}
        </div>

            {/* Simple Book a Demo Information Display */}
      <div className="contact-info-box mt-4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="info-card p-4 text-center" style={{
              backgroundColor: '#f8f9fa',
              border: '2px solid #BFD42F',
              borderRadius: '12px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}>
              <h4 style={{ color: '#000', marginBottom: '20px' }}>Email: BookAdemo@cloudvisorwealth.com</h4>
              <div style={{ fontSize: '16px', lineHeight: '1.6' }}>
                {/* <p style={{ margin: '8px 0', fontWeight: '500' }}>
                  <strong>Ismail Pishori</strong>
                </p> */}
                {/* <p style={{ margin: '8px 0' }}>
                  <a href="#" style={{ 
                    color: '#060700ff', 
                    textDecoration: 'none',
                    fontWeight: '500'
                  }}>
                    BookAdemo@cloudvisorwealth.com
                  </a>
                </p> */}
                <p style={{ margin: '8px 0', color: '#666' }}>
                  <img src={CompanyLogo} alt="Cloudvisor Wealth" style={{ maxWidth: '150px', height: 'auto' }} />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
      <footer className="site-footer">
        <div className="container text-center">
            <p>&copy; {new Date().getFullYear()} Cloudvisor DigitalAssociate. All rights reserved.</p>
        </div>
    </footer>

    </div>
  );
}

export default BookDemo;